import { Component, OnInit, DoCheck, LOCALE_ID, Inject } from '@angular/core';
import { Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BudgetDetailDetailService } from '../../../../service/budget-detail.service';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { CostService } from '../../../../service/cost.service';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-budget-detail-item',
  templateUrl: './budget-detail-item.component.html',
  styleUrls: ['./budget-detail-item.component.less']
})
export class BudgetDetailItemComponent implements OnInit, DoCheck {

  // 业务类型提示框
  typeTooltip = '请选择';
  // 业务类型上一次的值
  lastJobTypeSelected: number;
  jobTypeSelected = -1;
  @ViewChild('costTypeTreeSelect') costTypeTreeSelect: NzTreeSelectComponent;
  @Input() code = 0; // 0表示新建 1表示编辑
  @Input() bdid: any; // 预算编号

  budgetDetail = null;
  beforeValue = '';
  typeMap = new Map<number, any>();
  pTypes = [];
  // cost_type
  costTypes = [];
  validateForm: FormGroup;
  formatter = (value: number): string => {
    return formatNumber(value, this.localeId, '1.2-2');
  }

  constructor(
    private fb: FormBuilder,
    private budgetDetailService: BudgetDetailDetailService,
    private costService: CostService,
    @Inject(LOCALE_ID) private localeId: string,
  ) { }

  async ngOnInit(): Promise<void> {
    this.validateForm = this.fb.group({
      bdname: [null, [Validators.required]],
      bdid: [{ value: null, disabled: true }],
      initValue: [null, [Validators.required]],
      createBy: [{ value: null, disabled: true }],
      costTypeId: [null, [Validators.required]],
      mark: [null]
    });
    // 填充下拉框
    // this.budgetDetailService.getCostTypeAll().then((value) => {
    //   this.directors = value;
    // });
    const types = await this.costService.getCostTypeList();
    this.costTypes = this.initCostTypeTree(types);
    // 编辑时先填充组件数据
    if (this.code === 1 || this.code === 2) {
      await this.budgetDetailService.getBudgetDetail(this.bdid).then((value) => {
        this.budgetDetail = value;
      });
      console.log('输出:' + this.budgetDetail.mark);
      // 将数据内容填充到组件中
      this.setValidateForm(this.budgetDetail);
      if (this.code === 2) {
        // 根据父组件传值来决定是否禁用整个表单
        this.validateForm.disable();
      }
    }
  }

  // 表单的的set方法
  setValidateForm(budgetDetail: any) {
    this.validateForm.get('bdname').setValue(!this.isEmpty(budgetDetail.bdname) ? budgetDetail.bdname : null),
      this.validateForm.get('bdid').setValue(!this.isEmpty(budgetDetail.bdid) ? budgetDetail.bdid : null),
      this.validateForm.get('initValue').setValue(!this.isEmpty(budgetDetail.initValue) ? budgetDetail.initValue : null),
      this.validateForm.get('createBy').setValue(!this.isEmpty(budgetDetail.createBy) ? budgetDetail.createBy : null),
      this.validateForm.get('mark').setValue(!this.isEmpty(budgetDetail.mark) ? budgetDetail.mark : null);
    this.validateForm.get('costTypeId').setValue(!this.isEmpty(budgetDetail.costTypeId) ? budgetDetail.costTypeId : null);
    // this.validateForm.controls.comprehensiveEvaluation.disable()
  }
  initCostTypeTree(types: any[]) {
    const costTypes = [];
    for (const type of types) {
      const node = {
        title: type.typeName,
        value: type.typeId,
        key: type.typeId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        costTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.typeId, node);
    }
    return costTypes;
  }

  treeSelectChanged(key: any) {
    if (key === -1){
      return;
    }
    this.fillTypeTooltip(key);
    if (!this.isEmpty(key)) {
      const node = this.costTypeTreeSelect.getTreeNodeByKey(key);
      if (node != null) {
        if (node.isLeaf) {
          this.beforeValue = key;
        } else {
          this.validateForm.get('costTypeId').setValue(this.beforeValue);
        }
      }
    }
  }
  ngDoCheck(): void {
    // 监听业务类型变量的数据变化
    if (this.lastJobTypeSelected !== this.jobTypeSelected && this.costTypeTreeSelect) {
      this.lastJobTypeSelected = this.jobTypeSelected;
      this.fillTypeTooltip(this.jobTypeSelected);
    }
  }

  fillTypeTooltip(key) {
    if (key !== undefined && key !== null) {
      if (this.costTypeTreeSelect) {
        let currentNode = this.costTypeTreeSelect.getTreeNodeByKey(key);
        if (currentNode != null) {
          // 获取叶子节点完整路径，用于提示框
          let toolTip = `${currentNode.origin.title}`;
          while (currentNode.getParentNode()) {
            currentNode = currentNode.getParentNode();
            toolTip = `${currentNode.origin.title}-->${toolTip}`;
          }
          this.typeTooltip = toolTip;
        }
      }
    }
  }

  getbudgetDetailForm() {
    return this.validateForm;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
